export default {
    list(state) {
        return state.list
    },
    total(state) {
        return state.total
    }
}
